import type { SVGProps } from "react";
export interface ClipboardQuestionIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ClipboardQuestionIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ClipboardQuestionIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.875 19V6A4.125 4.125 0 0 1 7 1.875h1.25l.115.006a1.125 1.125 0 0 1 0 2.238l-.115.006H7c-1.036 0-1.875.84-1.875 1.875v13c0 1.036.84 1.875 1.875 1.875h10c1.036 0 1.875-.84 1.875-1.875V6c0-1.035-.84-1.875-1.875-1.875h-1.25a1.125 1.125 0 0 1 0-2.25H17A4.125 4.125 0 0 1 21.125 6v13A4.126 4.126 0 0 1 17 23.125H7A4.125 4.125 0 0 1 2.875 19"
      />
      <path
        fill={color}
        d="M12.875 12.01V12a.883.883 0 0 0-.874-.876c-.449 0-.835.312-.93.607l-2.14-.696c.425-1.307 1.74-2.16 3.07-2.16A3.133 3.133 0 0 1 15.125 12v.008c0 1.398-.861 2.193-1.491 2.622a9 9 0 0 1-.529.325 1.124 1.124 0 0 1-2.23-.206v-.3c0-.497.279-.823.42-.963a2.4 2.4 0 0 1 .423-.323c.303-.19.403-.226.649-.393.37-.252.508-.454.508-.762Zm-1.805-.279a1.126 1.126 0 0 1-2.14-.696zm2.304 6.27a1.374 1.374 0 0 1-2.742.14l-.007-.14.007-.141a1.375 1.375 0 0 1 1.369-1.235l.14.007A1.375 1.375 0 0 1 13.374 18ZM14.874 4A.875.875 0 0 0 14 3.125h-4A.875.875 0 0 0 9.125 4v.375h5.75zm2.25 1c0 .897-.726 1.625-1.624 1.625h-7A1.625 1.625 0 0 1 6.875 5V4A3.125 3.125 0 0 1 10 .875h4A3.125 3.125 0 0 1 17.125 4v1Z"
      />
    </svg>
  );
}
